module.exports = __webpack_public_path__ + "img/inter_1.0a25f18b.gif";